import type { Maybe } from '@adornis/base/utilTypes.js';
import { Int } from '@adornis/baseql/baseqlTypes.js';
import { registerQuery } from '@adornis/baseql/metadata/register.js';
import { getRawCollection } from '@adornis/baseql/server/collections.js';
import type { BaseQLSelectionSet, NarrowedEntity } from '@adornis/baseql/utils/queryGeneration.js';
import { Workshop } from '@adornis/buchungsheld-db/entities/workshop.js';
import { DateTime } from 'luxon';
import { Institution } from '../entities/institution.js';
import { getRecomendedWorkshopsAggregation } from '../server/logic/recommendations.js';

// logger.info(
//   { aggregation: getRecomendedWorkshopsAggregation('67360c9cc03623016595566e', null, DateTime.now()) },
//   'registered getWorkshopRecommendations',
// );

export const getWorkshopRecommendations = registerQuery({
  type: () => [Workshop],
  operationName: 'getWorkshopRecommendations',
  params: [
    { type: () => String, name: 'institutionID' },
    { type: () => String, name: 'userID' },
    { type: () => Int, name: 'limit' },
  ],
  resolve: (institutionID: Maybe<string>, userID: string, limit = 10) => {
    return async <SelSet extends BaseQLSelectionSet<Workshop>>(gqlFields: SelSet) => {
      const institutionCollection = await getRawCollection(Institution._collectionName);
      const workshopAggregation = getRecomendedWorkshopsAggregation(userID, institutionID, DateTime.now(), limit);
      const workshops = await institutionCollection.aggregate(workshopAggregation).toArray();

      return workshops as NarrowedEntity<Workshop, SelSet>[];
    };
  },
});
